module.exports = __webpack_public_path__ + "img/2-2.f96a270e.png";